import { render, staticRenderFns } from "./Curve2DField.vue?vue&type=template&id=35323337&lang=pug&"
import script from "./Curve2DField.vue?vue&type=script&lang=js&"
export * from "./Curve2DField.vue?vue&type=script&lang=js&"
import style0 from "./Curve2DField.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/node/authoring/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35323337')) {
      api.createRecord('35323337', component.options)
    } else {
      api.reload('35323337', component.options)
    }
    module.hot.accept("./Curve2DField.vue?vue&type=template&id=35323337&lang=pug&", function () {
      api.rerender('35323337', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/inspector/fields/Curve2DField.vue"
export default component.exports